import React from 'react'
import { useComputed } from "@preact/signals-react"
import { AppAffectedList, AppValueChip } from "@components"
import { reportListMultipleData } from "Pages/ReportsAlerts/Reports/@signals"

export default function MultipleModalFrequencyInfoSection() {
	const reportsInfo = useComputed(() => reportListMultipleData.value.reportsInfo)

	return <AppAffectedList
		hint="current schedule"
		rows={reportsInfo.value.map(({ name, idFrequencyWhenTranslation, frequencyHours }, idx) => ({
			key: `${name}-${idx}`,
			name,
			content: <>
				{!!idFrequencyWhenTranslation && <AppValueChip>{idFrequencyWhenTranslation}</AppValueChip>}
				{!!frequencyHours?.length && <AppValueChip>{frequencyHours.join(', ')}</AppValueChip>}
			</>,
		}))}
	/>
}
